// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_kl-0";
export var fileCarousel = "_kl-2";
export var removeFileButton = "_kl-1";